import { Action } from 'redux';
import { FUTURE } from 'src/modules/common/types/Future';
import {
  MODAL_PROFILE_ERROR_CLOSE,
  MODAL_PROFILE_ERROR_OPEN,
  MODAL_PROFILE_ERROR_RETRY,
} from 'src/modules/modals/actions/ModalActions';
import { ModalStackState } from 'src/modules/modals/types/ModalStackState';

export function modalProfileErrorReducer(state: ModalStackState, action: Action): ModalStackState {
  if (MODAL_PROFILE_ERROR_OPEN.is(action)) {
    const filteredState = state.filter((it) => it.type !== 'profile-error');

    return [...filteredState, {
      type: 'profile-error',
      data: action.data,
      status: null,
    }];
  }
  if (MODAL_PROFILE_ERROR_CLOSE.is(action)) {
    return state.filter((it) => it.type !== 'profile-error');
  }

  if (MODAL_PROFILE_ERROR_RETRY.isPending(action)) {
    return state.map((it) => (
      it.type === 'profile-error'
        ? { ...it, status: FUTURE.pending() }
        : it
    ));
  }
  if (MODAL_PROFILE_ERROR_RETRY.isSuccess(action)) {
    return state.map((it) => (
      it.type === 'profile-error'
        ? { ...it, status: FUTURE.success(action.data) }
        : it
    ));
  }
  if (MODAL_PROFILE_ERROR_RETRY.isFailure(action)) {
    return state.map((it) => (
      it.type === 'profile-error'
        ? { ...it, status: FUTURE.failure(action.data) }
        : it
    ));
  }

  return state;
}
